<script>
  export let tableData;
  export let tableColumns;
  export let tableID = "table";
</script>

<table id={tableID}>
  <thead>
    <tr>
      {#each tableColumns as col}
        <th>{col}</th>
      {/each}
    </tr>
  </thead>
  <tbody>
    {#each tableData as row, i}
      <tr class={i % 2 == 0 ? "even" : "odd"}>
        {#each tableColumns as col}
          <td>{row[col]}</td>
        {/each}
      </tr>
    {/each}
  </tbody>
</table>

<style>
  table {
    font-size: 0.85rem;
    color: #666666;
  }
  th,
  td {
    padding: 0.15rem 0.35rem !important;
  }
  th {
    font-weight: 400;
  }
  .even {
    background-color: rgba(0, 0, 0, 0.085) !important;
  }
</style>
